import Image1 from '../../assets/images/hero/1.jpg'
import Image2 from '../../assets/images/hero/2.jpg'
import Image3 from '../../assets/images/hero/3.jpg'
import Image4 from '../../assets/images/hero/4.jpg'
import Image5 from '../../assets/images/hero/5.png'
import Image6 from '../../assets/images/hero/6.jpg'

export const SlideData = [
    { img: Image1 },
    { img: Image2 },
    { img: Image3 },
    { img: Image4 },
    { img: Image5 },
    { img: Image6 }
]